var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(item,itemIndex){return _c('WsText001',{key:itemIndex,attrs:{"h2":item.h2,"h3":item.h3,"bold":item.bold}},[_vm._v(_vm._s(item.title))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }